<template>



  <div class="filters__cards-block">
<!--    <div class="filters__cards-buttons">-->
<!--      &lt;!&ndash;      <button>В наличии</button>&ndash;&gt;-->
<!--      <button class="activeButtonCard" @click="fetchProducts('discount')">Акции и распродажи</button>-->
<!--      <button @click="fetchProducts('popular')">Популярное</button>-->
<!--      <button @click="fetchProducts('cheap')">Сначала недорогие</button>-->
<!--    </div>-->
    <div class="filters__cards-content">
      <div class="filters__cards"><!-- Первый блок товаров (до 8) -->
        <ProductItem
            v-for="product in products.slice(0, 8)"
            :key="product.id"
            :product="product"
            @add-to-cart="addToCart"
            :is-auth="isAuth"
        />
      </div>

      <ExclusivesDiscount v-if="!isAuth" />

      <!-- Второй блок товаров (остальные) -->
      <div class="filters__cards">
        <ProductItem
            v-for="product in products.slice(8)"
            :key="product.id"
            :product="product"
            @add-to-cart="addToCart"
            :is-auth="isAuth"
        />

      </div>
    </div>
  </div>

  <PaginationProducts
      v-model="currentPage"
      :page-count="totalPages"
      @page-changed="handlePageChange"
  />


</template>

<script>
import Treeselect from '@zanmato/vue3-treeselect';
import VsSelect from 'vs-vue3-select';
import cart from '../scripts/shop-cart';
import axios from 'axios';
import ProductItem from '../components/ProductItem.vue';

import PaginationProducts from "./PaginationProducts.vue";
import ExclusivesDiscount from "./ExclusivesDiscount.vue";

export default {
  components: {ExclusivesDiscount, PaginationProducts, Treeselect, VsSelect, ProductItem,},
  data() {
    return {
      product_collection_options: [],
      brand_options: [],
      manufacturer_options: [],
      isAuth: window.IS_AUTHENTICATED,
      availableFilters: {},
      products: [],
      totalPages: 0, // Общее количество страниц
      currentPage: 1, // Текущая страница
      limit: 16,
      isFirstLoad: true,
    };
  },
  methods: {
    async fetchProducts(order_by = '') {
      console.log('Filters:', this.filters);

      // Собираем все фильтры в один объект для запроса
      let query = {};

      query['favorites'] = 'true';

      // Добавляем динамические фильтры
      for (const key in this.filters) {
        if (this.filters[key] && this.filters[key].length > 0) {
          query[key] = this.filters[key];
        }
      }

      if (typeof order_by === 'string' || order_by instanceof String) {
        const order_params = ['discount', 'popular', 'cheap'];
        const is_order_by = order_params.includes(order_by);
        if (is_order_by)
          query['order_by'] = order_by;
      }

      query['page'] = this.currentPage;

      // Выполняем запрос к API
      axios.post('/api/products', query)
          .then(response => {
            console.log('Products fetch response:', response.data);
            this.totalPages = response.data.totalPages;
            this.products = response.data.products;

          })
          .catch(error => {
            console.error('Error fetching products:', error);
            alert("Ошибка при загрузке продуктов: " + error.message);
          });
    },

    handlePageChange(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchProducts();
    },

    addToCart(productId) {

      let modalBasketAdd = document.querySelector('.modal-basket');

      cart.addItem(productId, 1).then(function (data) {
        let product_image = modalBasketAdd.querySelector('.product-image img');
        let product_name = modalBasketAdd.querySelector('a.product-name');
        let product_price_one = modalBasketAdd.querySelector('span.product-price');
        let product_desc = modalBasketAdd.querySelector('p.desc-cart-item');
        let item_active = data['cart_item']['item_active'];
        let quantity = item_active['quantity'];
        let price = item_active['price'];

        product_image.src = '/images/products/' + item_active.image;
        product_name.textContent = item_active.name;
        product_price_one.textContent = price + ' р';

        const wordForms = ['товар', 'товара', 'товаров'];
        const lastDigit = quantity % 10;
        const lastTwoDigits = quantity % 100;
        let wordForm
        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
          wordForm = wordForms[2]; // "товаров"
        } else {
          if (lastDigit === 1) {
            wordForm = wordForms[0]; // "товар"
          } else if (lastDigit >= 2 && lastDigit <= 4) {
            wordForm = wordForms[1]; // "товара"
          } else {
            wordForm = wordForms[2]; // "товаров"
          }
        }
        // Перемножаем количество и цену и округляем до целого числа
        const totalPrice = Math.round(quantity * price);
        product_desc.textContent = 'В корзине ' + quantity + ' ' + wordForm + ' на сумму ' + totalPrice + ' р';

        modalBasketAdd.classList.add('activeModalBasket');
      }).catch(function (error) {
        console.error('Error adding item to cart:', error);
        this.showError('Ошибка при добавлении товара в корзину.');
      }.bind(this));

    },
  },
  mounted() {
    this.fetchProducts();
  },
};
</script>